import {BaseContainerModel} from '../base-container.model';
import {app_mst_grp_hdr_RowClass} from '../../dbschema';
import {app_mst_grp_ext_RowClass} from '../../dbschema/app_mst_grp_ext.model';
import {app_mst_grp_line_RowClass} from '../../dbschema/app_mst_grp_line.model';


export class TeamContainerModel extends BaseContainerModel {
  app_mst_grp_hdr: app_mst_grp_hdr_RowClass = new app_mst_grp_hdr_RowClass();
  app_mst_grp_exts: app_mst_grp_ext_RowClass[] = [];
  app_mst_grp_lines: app_mst_grp_line_RowClass[] = [];
}
